/**
 * ページ左固定メニューをマウスオーバーした時のメニュー展開処理
 */
export function categoryMenuView() {
  const headerCategoryListAll = document.querySelectorAll('.js-headerCategoryList');
  const IS_MOUSEOVER = 'is-mouseover';
  const IS_VIEW = 'is-view';

  headerCategoryListAll.forEach((target) => {
    const targetInMenu = target.querySelector('.js-headerCategory');

    target.addEventListener('mouseover', () => {
      target.classList.add(IS_MOUSEOVER);
      targetInMenu.classList.add(IS_VIEW);
    });

    target.addEventListener('mouseleave', () => {
      target.classList.remove(IS_MOUSEOVER);
      targetInMenu.classList.remove(IS_VIEW);
    });
  });
}
